import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationService } from '../../../providers/navigation.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { ApiService } from '../../../providers/api.service';
import { Subscription } from 'rxjs';
import { SM_CONSTANTS } from '../../../shared/constants/sm-constants';
import { ITableColumnHeader } from '../../../models/table-column-header';
import { AddServiceComponent } from 'src/app/shared/components/add-service/add-service.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from '../../../providers/shared.service';
import { FormControl } from '@angular/forms';
import { AddServiceTemplateItemComponent } from 'src/app/shared/components/add-service-template-item/add-service-template-item.component';
import { AddServiceTimingsComponent } from 'src/app/shared/components/add-service-timings/add-service-timings.component';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { MessagingService } from 'src/app/providers/messaging.service';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { TranslateService } from '@ngx-translate/core';
import { YoutubeEmbedVideoComponent } from '../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component';
import { AuthService } from 'src/app/providers/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MeetingDataComponent } from '../../new-v2-pages/new-v2-component/meeting-data/meeting-data.component';

@Component({
  selector: 'sm-service-timings',
  templateUrl: './service-timings.component.html',
  styleUrls: ['./service-timings.component.scss']
})
export class ServiceTimingsComponent implements OnInit, OnDestroy {

//---------------NEW CODE ----------------------

serviceType: string = '';
entityHashId: string = '';
loader: boolean = false;
apisub: Subscription
businessListData: any[] = []
serviceTimings: any[] = []
finalServiceTimings: any[] = []
selectedBusiness:any
selectedServiceType: any = '0'
groupedServiceTimings:any = null
toShowTimings: boolean = false
daysOfWeek = [
  { day: 1, name: 'Sunday' },
  { day: 2, name: 'Monday' },
  { day: 3, name: 'Tuesday' },
  { day: 4, name: 'Wednesday' },
  { day: 5, name: 'Thursday' },
  { day: 6, name: 'Friday' },
  { day: 7, name: 'Saturday' }
];
constructor(
  private apiservice: ApiService,
  private loaderservice: LoaderServiceService,
  private navservice: NavigationService,
  private router: Router,
  private _modelRef: MatDialog,
  private dialog:MatDialog,
  private authService:AuthService,
  private route: ActivatedRoute,
  private snackBar:MatSnackBar
) {
  this.navservice.hideSidebarAndNav = false;
  this.apisub = this.apiservice.apiResult.subscribe(resdata => {

    if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_HOME_SERVICE_TIMINGS){
      this.serviceTimings = []
      this.groupedServiceTimings = null
      this.toShowTimings = false
      if(resdata.result){
        resdata.result.forEach((element:any) => {
          element.timeList = JSON.parse(element.timeList)
        });

        console.log(resdata.result);

      resdata.result.forEach((element:any) => {
        if(element.timeList.length > 1){
          element.timeList.forEach((childItem:any, index:number) => {
            childItem.toShowType = index == 0 ? 'parent' : 'child'
            childItem.closeTime = this.convertTo12HourFormat(childItem.closeTime)
            childItem.openTime = this.convertTo12HourFormat(childItem.openTime)
            this.serviceTimings.push(childItem)
          });
        }else{
          element.timeList[0].toShowType = 'parent'
          element.timeList[0].closeTime = this.convertTo12HourFormat(element.timeList[0].closeTime)
          element.timeList[0].openTime = this.convertTo12HourFormat(element.timeList[0].openTime)
          this.serviceTimings.push(element.timeList[0])
        }
        
      });

      console.log(this.serviceTimings);
      
      this.finalServiceTimings = []
      for (let index = 0; index < this.daysOfWeek.length; index++) {
        let dayFound = false; // Flag to keep track if the day was found in serviceTimings
      
        for (let j = 0; j < this.serviceTimings.length; j++) {
          if (this.daysOfWeek[index].day === this.serviceTimings[j].day) {
            this.serviceTimings[j].status = 1;
            this.serviceTimings[j].dayName = this.daysOfWeek[index].name 
            this.finalServiceTimings.push(this.serviceTimings[j]);
            dayFound = true;
          }
        }
      
        if (!dayFound) {
          let data = {
            day: this.daysOfWeek[index].day,
            dayName: this.daysOfWeek[index].name,
            hashId: null,
            openTime: '---',
            closeTime: '---',
            operationDate: null,
            specialDayStatus: null,
            toShowType: 'parent',
            status: 0
          };
          this.finalServiceTimings.push(data);
        }
      }
      console.log(this.finalServiceTimings);
      this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
      this.toShowTimings = true
     }
     else{
      this.finalServiceTimings = []
      for (let index = 0; index < this.daysOfWeek.length; index++) {
        // let dayFound = false; 
        // for (let j = 0; j < this.serviceTimings.length; j++) {
        //   if (this.daysOfWeek[index].day === this.serviceTimings[j].day) {
        //     this.serviceTimings[j].status = 1;
        //     this.serviceTimings[j].dayName = this.daysOfWeek[index].name 
        //     this.finalServiceTimings.push(this.serviceTimings[j]);
        //     dayFound = true;
        //   }
        // }
      
       
          let data = {
            day: this.daysOfWeek[index].day,
            dayName: this.daysOfWeek[index].name,
            hashId: null,
            openTime: '---',
            closeTime: '---',
            operationDate: null,
            specialDayStatus: null,
            toShowType: 'parent',
            status: 0
          };
          this.finalServiceTimings.push(data);
      
      }
      this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
      this.toShowTimings = false
     }
     
     
     this.loaderservice.showLoader = false
     this.loader = false
     
    }
    else if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_SHOP_SERVICE_TIMINGS){
      this.serviceTimings = []
      this.groupedServiceTimings = null
      this.toShowTimings = false
      if(resdata.result){
        resdata.result.forEach((element:any) => {
          element.timeList = JSON.parse(element.timeList)
        });

        console.log(resdata.result);

      resdata.result.forEach((element:any) => {
        if(element.timeList.length > 1){
          element.timeList.forEach((childItem:any, index:number) => {
            childItem.toShowType = index == 0 ? 'parent' : 'child'
            childItem.closeTime = this.convertTo12HourFormat(childItem.closeTime)
            childItem.openTime = this.convertTo12HourFormat(childItem.openTime)
            this.serviceTimings.push(childItem)
          });
        }else{
          element.timeList[0].toShowType = 'parent'
          element.timeList[0].closeTime = this.convertTo12HourFormat(element.timeList[0].closeTime)
          element.timeList[0].openTime = this.convertTo12HourFormat(element.timeList[0].openTime)
          this.serviceTimings.push(element.timeList[0])
        }
        
      });

      console.log(this.serviceTimings);
      
      this.finalServiceTimings = []
      for (let index = 0; index < this.daysOfWeek.length; index++) {
        let dayFound = false; // Flag to keep track if the day was found in serviceTimings
      
        for (let j = 0; j < this.serviceTimings.length; j++) {
          if (this.daysOfWeek[index].day === this.serviceTimings[j].day) {
            this.serviceTimings[j].status = 1;
            this.serviceTimings[j].dayName = this.daysOfWeek[index].name 
            this.finalServiceTimings.push(this.serviceTimings[j]);
            dayFound = true;
          }
        }
      
        if (!dayFound) {
          let data = {
            day: this.daysOfWeek[index].day,
            dayName: this.daysOfWeek[index].name,
            hashId: null,
            openTime: '---',
            closeTime: '---',
            operationDate: null,
            specialDayStatus: null,
            toShowType: 'parent',
            status: 0
          };
          this.finalServiceTimings.push(data);
        }
      }
      console.log(this.finalServiceTimings);
      this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
      this.toShowTimings = true
     }
     else{

      this.finalServiceTimings = []
      for (let index = 0; index < this.daysOfWeek.length; index++) {
      
      
       
          let data = {
            day: this.daysOfWeek[index].day,
            dayName: this.daysOfWeek[index].name,
            hashId: null,
            openTime: '---',
            closeTime: '---',
            operationDate: null,
            specialDayStatus: null,
            toShowType: 'parent',
            status: 0
          };
          this.finalServiceTimings.push(data);
      
      }
      this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
      this.toShowTimings = false
     }
     this.loaderservice.showLoader = false
     this.loader = false
    }
    if (
      resdata.responseType ===
      SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_HOME_SERVICE_TIMINGS
    ) {
      if (resdata.result) {
        if(this.serviceType == '0'){
          this.apiservice.getHomeServiceTimeDetails(this.entityHashId)
        }
        else if(this.serviceType == '1'){
          this.apiservice.getShopEntityTimeDetails(this.entityHashId)
        }
      }
    }
    if (
      resdata.responseType ===
      SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_SHOP_SERVICE_TIMINGS
    ) {
      if (resdata.result) {
        if(this.serviceType == '0'){
          this.apiservice.getHomeServiceTimeDetails(this.entityHashId)
        }
        else if(this.serviceType == '1'){
          this.apiservice.getShopEntityTimeDetails(this.entityHashId)
        }
      }
    }
    if (
      resdata.responseType ===
      SM_CONSTANTS.RESULT_API_UPDATE_VIRTUAL_SERVICE_TIMINGS
    ) {
      if (resdata.result) {
        if(this.serviceType == '0'){
          this.apiservice.getHomeServiceTimeDetails(this.entityHashId)
        }
        else if(this.serviceType == '1'){
          this.apiservice.getShopEntityTimeDetails(this.entityHashId)
        }
        else if(this.serviceType == '2'){
          this.apiservice.getVirtualServiceTimings(this.entityHashId)
        }
      }
    }
     if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_VIRTUAL_SERVICE_TIMINGS){
      this.serviceTimings = []
      this.groupedServiceTimings = null
      this.toShowTimings = false
      if(resdata.result){
        let formattedData = this.formatTimeDataForVirtual(resdata.result)
        // resdata.result.forEach((element:any) => {
        //   element.timeList = JSON.parse(element.timeList)
        // });

        console.log(resdata.result);

        formattedData.forEach((element:any) => {
        if(element.timeList.length > 1){
          element.timeList.forEach((childItem:any, index:number) => {
            childItem.toShowType = index == 0 ? 'parent' : 'child'
            childItem.closeTime = this.convertTo12HourFormat(childItem.closeTime)
            childItem.openTime = this.convertTo12HourFormat(childItem.openTime)
            this.serviceTimings.push(childItem)
          });
        }else{
          element.timeList[0].toShowType = 'parent'
          element.timeList[0].closeTime = this.convertTo12HourFormat(element.timeList[0].closeTime)
          element.timeList[0].openTime = this.convertTo12HourFormat(element.timeList[0].openTime)
          this.serviceTimings.push(element.timeList[0])
        }
        
      });

      console.log(this.serviceTimings);
      
      this.finalServiceTimings = []
      for (let index = 0; index < this.daysOfWeek.length; index++) {
        let dayFound = false; // Flag to keep track if the day was found in serviceTimings
      
        for (let j = 0; j < this.serviceTimings.length; j++) {
          if (this.daysOfWeek[index].day === this.serviceTimings[j].day) {
            this.serviceTimings[j].status = 1;
            this.serviceTimings[j].dayName = this.daysOfWeek[index].name 
            this.finalServiceTimings.push(this.serviceTimings[j]);
            dayFound = true;
          }
        }
      
        if (!dayFound) {
          let data = {
            day: this.daysOfWeek[index].day,
            dayName: this.daysOfWeek[index].name,
            hashId: null,
            openTime: '---',
            closeTime: '---',
            operationDate: null,
            specialDayStatus: null,
            toShowType: 'parent',
            status: 0
          };
          this.finalServiceTimings.push(data);
        }
      }
      console.log(this.finalServiceTimings);
      this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
      this.toShowTimings = true
     }
     else{

      this.finalServiceTimings = []
      for (let index = 0; index < this.daysOfWeek.length; index++) {
      
      
       
          let data = {
            day: this.daysOfWeek[index].day,
            dayName: this.daysOfWeek[index].name,
            hashId: null,
            openTime: '---',
            closeTime: '---',
            operationDate: null,
            specialDayStatus: null,
            toShowType: 'parent',
            status: 0
          };
          this.finalServiceTimings.push(data);
      
      }
      this.groupedServiceTimings = this.groupBy(this.finalServiceTimings, 'dayName');
      this.toShowTimings = false
     }
     this.loaderservice.showLoader = false
     this.loader = false
    }
  })
}

isOwner: boolean = false
ngOnInit(): void {
  this.isOwner = this.authService.isOwner() 
  // localStorage.removeItem(SM_CONSTANTS.CURRENT_ENTITY_HASH);
  this.loader = true
  this.route.queryParams.subscribe(data => {
    console.log(data.entityHash);
    this.entityHashId = data.entityHash
    this.serviceType = data.serviceType
    
  })
  if(this.serviceType == '0'){
      this.loaderservice.showLoader = true
      this.apiservice.getHomeServiceTimeDetails(this.entityHashId)
    }
    else if(this.serviceType == '1'){
      this.loaderservice.showLoader = true
      this.apiservice.getShopEntityTimeDetails(this.entityHashId)
    }
    else if(this.serviceType == '2'){
      this.loaderservice.showLoader = true
      this.apiservice.getVirtualServiceTimings(this.entityHashId)
    }
}

changeTimingsViewStatus(){
this.toShowTimings = true
}

//   "session",
//   "startTime",
//   "stopTime",
//   "actions",
// ];
// sessions = [
//   {
//     day: "Sunday",
//     session: "1",
//     startTime: "9:00 AM",
//     stopTime: "02:00 PM",
//     rowspan: 1,
//     showDay: true,
//   },
//   {
//     day: "",
//     session: "2",
//     startTime: "10:00 AM",
//     stopTime: "11:00 PM",
//     rowspan: 1,
//     showDay: false,
//   },
//   // Add more session objects as needed
//   {
//     day: "Monday",
//     session: "1",
//     startTime: "9:00 AM",
//     stopTime: "10:00 AM",
//     rowspan: 1,
//     showDay: true,
//   },
//   {
//     day: "",
//     session: "2",
//     startTime: "10:00 AM",
//     stopTime: "11:00 AM",
//     rowspan: 1,
//     showDay: false,
//   },
//   {
//     day: "Tuesday",
//     session: "1",
//     startTime: "9:00 AM",
//     stopTime: "11:00 PM",
//     rowspan: 1,
//     showDay: true,
//   },
//   {
//     day: "Wednesday",
//     session: "1",
//     startTime: "9:00 AM",
//     stopTime: "11:00 PM",
//     rowspan: 1,
//     showDay: true,
//   },
//   {
//     day: "Thursday",
//     session: "1",
//     startTime: "9:00 AM",
//     stopTime: "10:00 AM",
//     rowspan: 1,
//     showDay: true,
//   },
//   {
//     day: "Friday",
//     session: "1",
//     startTime: "9:00 AM",
//     stopTime: "10:00 AM",
//     rowspan: 1,
//     showDay: true,
//   },
//   {
//     day: "Saturday",
//     session: "1",
//     startTime: "9:00 AM",
//     stopTime: "10:00 AM",
//     rowspan: 1,
//     showDay: true,
//   },
// ];
openAddTime(rowvalue:any){
  rowvalue.serviceType = this.serviceType
  rowvalue.entityHash = this.entityHashId
  let dialogref = this._modelRef.open(AddServiceTimingsComponent, {
    width: '500px',
    data: {
      title: 'Add service timing',
      ref: this._modelRef,
      data: rowvalue
    },
  });
  dialogref.afterClosed().subscribe(res =>{
    if(res){
      // if(this.serviceType == '0'){
      //   this.apiservice.getHomeServiceTimeDetails(this.entityHashId)
      // }
      // else if(this.serviceType == '1'){
      //   this.apiservice.getShopEntityTimeDetails(this.entityHashId)
      // }
      // else if(this.serviceType == '2'){
      //   this.apiservice.getVirtualServiceTimings(this.entityHashId)
      // }

    }
  })
}

removeTime(rowvalue:any){
  if(this.serviceType == '0'){
    let data = {
      homeServiceTimeInfo : {
        timeList : [
          {
            hashId: rowvalue.hashId,
            status: 2
          }
        ]
      }
    }
    this.loaderservice.showLoader = true
    this.apiservice.updateHomeServiceTimeInfo(
      this.entityHashId,
      data
    );
  }
  else if(this.serviceType == '1'){
    let data = {
      entityTimeInfo : {
        timeList : [
          {
            hashId: rowvalue.hashId,
            status: 2
          }
        ]
      }
    }
    this.loaderservice.showLoader = true
    this.apiservice.updateEntityShopTimeInfo(
      this.entityHashId,
      data
    );
  }
  else if(this.serviceType == '2'){
    let data = 
    {
      "entityHash": this.entityHashId,
      "timeList": [
          {
              "hashId": rowvalue.hashId,
              "status": "2"
             
          }
      ]
  }

    this.loaderservice.showLoader = true
    this.apiservice.updateVirtualServiceTimingInfo(
      data
    );
  }
}


convertTo12HourFormat(timeString:any) {
  
  const [hours, minutes] = timeString.split(':');
  let period = 'AM';
  let hour = parseInt(hours, 10);

  if (hour >= 12) {
    period = 'PM';
    if (hour > 12) {
      hour -= 12;
    }
  }

  return `${hour.toString().padStart(2, '0')}:${minutes} ${period}`;
}
groupBy(array: any, key: any) {
// Step 1: Group the input array by the specified key
const grouped = array.reduce((acc:any, curr:any) => {
  if (!acc[curr[key]]) {
    acc[curr[key]] = [];
  }
  acc[curr[key]].push(curr);
  return acc;
}, {});

// Step 2: Transform the grouped object into an array of objects with timelist
return Object.values(grouped).map(timelist => ({ timelist }));
}

ngOnDestroy(): void {
this.apisub.unsubscribe()
}


openvideo(){
this.dialog.open(YoutubeEmbedVideoComponent,{
width:'1000px',
disableClose:true,
data:{
  link:"https://www.youtube.com/embed/2j7x8epzSLw",
  title: 'Setting Business Hours in LookzUp Web Portal.'
}})
}

opencontact(){
  this.router.navigate(['/contact-us']);
}

formatTimeData(data: any) {
  const groupedData: { [key: number]: any } = {};

  data.forEach((item:any) => {
    const formattedItem = {
      day: item.day,
      hashId: item.hash_id,
      openTime: `${item.open_time}.000000`,
      closeTime: `${item.close_time}.000000`,
      operationDate: null,
      specialDayStatus: item.special_day_status
    };

    if (!groupedData[item.day]) {
      groupedData[item.day] = { timeList: [formattedItem] };
    } else {
      groupedData[item.day].timeList.push(formattedItem);
    }
  });

  return Object.values(groupedData);
}
formatTimeDataForVirtual(data: any) {
  const groupedData: { [key: number]: any } = {};

  data.forEach((item:any) => {
    const formattedItem = {
      day: item.day,
      hashId: item.hash_id,
      openTime: `${item.open_time}.000000`,
      closeTime: `${item.close_time}.000000`,
      operationDate: null,
      specialDayStatus: item.special_day_status,
      meeting_details: item.meeting_details ? (typeof item.meeting_details == 'string' ? JSON.parse(item.meeting_details) : item.meeting_details) : null
    };

    if (!groupedData[item.day]) {
      groupedData[item.day] = { timeList: [formattedItem] };
    } else {
      groupedData[item.day].timeList.push(formattedItem);
    }
  });

  return Object.values(groupedData);
}
openLink(url: string): void {
  window.open(url, '_blank');
}

configureUnavailability(){
  // this.snackBar.open("Coming soon in next version.", "Ok", {
  //   duration: 5000,
  //   horizontalPosition: "center",
  //   verticalPosition: "bottom",
  // });
  this.router.navigate(['unavailability'],{queryParamsHandling: 'preserve', relativeTo:this.route})
}
openAddEditMeetingDetails(item:any){
  let dialogref = this.dialog.open(MeetingDataComponent,{
    width: '500px',
    data:{
      data: item,
      isOwner: this.isOwner
    }
  })
  dialogref.afterClosed().subscribe(data => {
    if(data){
      this.apiservice.getVirtualServiceTimings(this.entityHashId)
    }
  })
}
}

